import { render, staticRenderFns } from "./TotalInteractionsChartInfoCard.vue?vue&type=template&id=305a8724"
import script from "./TotalInteractionsChartInfoCard.vue?vue&type=script&lang=ts"
export * from "./TotalInteractionsChartInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports